import { lightColors, darkColors, type ColorTokens } from './colors';
import {
  space,
  spaceAlias,
  fontSize,
  fontFamily,
  fontWeight,
  letterSpacing,
  lineHeight,
  radius,
  elevation,
  transition,
  zIndex,
  focus,
  motion,
} from './scales';

function buildTheme(colors: ColorTokens) {
  return {
    colors,
    space,
    spaceAlias,
    fontSize,
    fontFamily,
    fontWeight,
    letterSpacing,
    lineHeight,
    radius,
    elevation,
    transition,
    zIndex,
    focus,
    motion,
  } as const;
}

export const lightTheme = buildTheme(lightColors);
export const darkTheme = buildTheme(darkColors);

export type OpsTheme = typeof lightTheme;
